import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id: string;
};

export const useVehicleMarkDelete = () => {
  const [vehicleMarkDeleteLoading, setVehicleMarkDeleteLoading] =
    useState(false);

  const vehicleMarkDeleteReq = useCallback(async (params: TParams) => {
    setVehicleMarkDeleteLoading(true);
    const res = await request({
      path: "vehicle-mark/delete",
      method: "POST",
      body: JSON.stringify(params),
    });
    setVehicleMarkDeleteLoading(false);
    return res?.data;
  }, []);

  return { vehicleMarkDeleteLoading, vehicleMarkDeleteReq };
};
